import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/elementix-landing-v2/elementix-landing-v2/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/elementix-landing-v2/elementix-landing-v2/components/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/elementix-landing-v2/elementix-landing-v2/node_modules/next/dist/client/app-dir/link.js");
